/* eslint-disable no-case-declarations */
import { CampaignCityReport } from "../../constants/action-constants/CampaignCityReportActionConstants";

const initialState = {
  // City-Summary ---------------------------------
  citySummary: {},
  citySummaryLoading: false,
  citySummaryError: "",
  citySummaryReport: {},
  previouscanBeApproximatedCount: 0,
  previousCannotBeApproximatedCount: 0,

  // Approx ots for city ----------------------------
  approxOtsForCityloading: false,
  isSuccess: false,

  // Pdf Report -------------------------------------
  downloadCityPdfReportLoading: false,
  cityPdfReportErr: "",
  isCityPdfReportDownloaded: false,
  cityPdfReportData: {},

  // Medias as Zip ----------------------------------
  downloadCityMediasPdfReportsZipLoading: false,
  cityMediasPdfReportsZipErr: "",
  isCityMediasPdfReportsZipDownloaded: false,
  cityMediasPdfReportsZipData: {},

  // City Media Single Pdf -------------------------------
  downloadCityMediasSinglePdfReportLoading: false,
  cityMediasSinglePdfReportErr: "",
  isCityMediasSinglePdfReportDownloaded: false,
  cityMediasSinglePdfReportData: {},

  // Download Campaign City Report Modal
  openDownloadCampaignCityReportModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // City overview
    //-------------------------------------------------------------------------------------
    case CampaignCityReport.GET_CITY_OVERVIEW:
      return {
        ...state,
        citySummaryLoading: true,
      };
    case CampaignCityReport.GET_CITY_OVERVIEW_SUCCESS: {
      const data = action.data;
      const {
        canBeApproximatedCount: previouscanBeApproximatedCount,
        cannotBeApproximatedCount: previousCannotBeApproximatedCount,
      } = data.summary;
      return {
        ...state,
        citySummary: data,
        citySummaryReport: data,
        citySummaryLoading: false,
        previouscanBeApproximatedCount,
        previousCannotBeApproximatedCount,
      };
    }
    case CampaignCityReport.GET_CITY_OVERVIEW_FAILURE:
      return {
        ...state,
        citySummaryLoading: false,
        citySummaryError: action.payload,
      };

    // Approx ots for city
    //-------------------------------------------------------------------------------------
    case CampaignCityReport.APPROX_OTS_FOR_CITY:
      return {
        ...state,
        approxOtsForCityloading: true,
      };
    case CampaignCityReport.APPROX_OTS_FOR_CITY_SUCCESS:
      return {
        ...state,
        approxOtsForCityloading: false,
        isSuccess: true,
      };
    case CampaignCityReport.APPROX_OTS_FOR_CITY_FAILURE:
      return {
        ...state,
        approxOtsForCityloading: false,
        error: action.payload,
      };

    // City Summary Report Pdf
    //-------------------------------------------------------------------------------------
    case CampaignCityReport.DOWNLOAD_CITY_PDF_REPORT:
      return {
        ...state,
        downloadCityPdfReportLoading: true,
        isCityPdfReportDownloaded: false,
      };
    case CampaignCityReport.DOWNLOAD_CITY_PDF_REPORT_SUCCESS: {
      const { isSentViaEmail, reportData } = action.payload || {};
      return {
        ...state,
        downloadCityPdfReportLoading: false,
        isCityPdfReportDownloaded: true,
        cityPdfReportData: { isSentViaEmail, reportData },
      };
    }
    case CampaignCityReport.DOWNLOAD_CITY_PDF_REPORT_FAILURE:
      return {
        ...state,
        downloadCityPdfReportLoading: false,
        isCityPdfReportDownloaded: false,
        cityPdfReportData: {},
        cityPdfReportErr: action.payload,
      };
    case CampaignCityReport.RESET_CITY_PDF_REPORT:
      return {
        ...state,
        isCityPdfReportDownloaded: false,
        cityPdfReportData: {},
      };

    // Download City Medias As Zip
    //-------------------------------------------------------------------------------------
    case CampaignCityReport.DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP:
      return {
        ...state,
        downloadCityMediasPdfReportsZipLoading: true,
        isCityMediasPdfReportsZipDownloaded: false,
      };
    case CampaignCityReport.DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP_SUCCESS: {
      const { isSentViaEmail, reportData } = action.payload || {};
      return {
        ...state,
        downloadCityMediasPdfReportsZipLoading: false,
        isCityMediasPdfReportsZipDownloaded: true,
        cityMediasPdfReportsZipData: { isSentViaEmail, reportData },
      };
    }
    case CampaignCityReport.DOWNLOAD_CITY_MEDIAS_PDF_REPORTS_ZIP_FAILURE:
      return {
        ...state,
        downloadCityMediasPdfReportsZipLoading: false,
        isCityMediasPdfReportsZipDownloaded: false,
        cityMediasPdfReportsZipData: {},
        cityMediasPdfReportsZipErr: action.payload,
      };
    case CampaignCityReport.RESET_CITY_MEDIAS_PDF_REPORTS_ZIP:
      return {
        ...state,
        isCityMediasPdfReportsZipDownloaded: false,
        cityMediasPdfReportsZipData: {},
      };

    // Download City Medias Single Pdf
    //-------------------------------------------------------------------------------------
    case CampaignCityReport.DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT:
      return {
        ...state,
        downloadCityMediasSinglePdfReportLoading: true,
        isCityMediasSinglePdfReportDownloaded: false,
      };
    case CampaignCityReport.DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT_SUCCESS: {
      const { isSentViaEmail, reportData } = action.payload || {};
      return {
        ...state,
        downloadCityMediasSinglePdfReportLoading: false,
        isCityMediasSinglePdfReportDownloaded: true,
        cityMediasSinglePdfReportData: { isSentViaEmail, reportData },
      };
    }
    case CampaignCityReport.DOWNLOAD_CITY_MEDIAS_SINGLE_PDF_REPORT_FAILURE:
      return {
        ...state,
        downloadCityMediasSinglePdfReportLoading: false,
        isCityMediasSinglePdfReportDownloaded: false,
        cityMediasSinglePdfReportData: {},
        cityMediasSinglePdfReportErr: action.payload,
      };
    case CampaignCityReport.RESET_CITY_MEDIAS_SINGLE_PDF_REPORT:
      return {
        ...state,
        isCityMediasSinglePdfReportDownloaded: false,
        cityMediasSinglePdfReportData: {},
      };

    // Download Campaign City Report Modal
    // -------------------------------------------------------------------------------
    case CampaignCityReport.OPEN_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL:
      return {
        ...state,
        openDownloadCampaignCityReportModal: true,
      };
    case CampaignCityReport.CLOSE_DOWNLOAD_CAMPAIGN_CITY_REPORT_MODAL:
      return {
        ...state,
        openDownloadCampaignCityReportModal: false,
      };

    default:
      return state;
  }
};
